const externalLinks = {
  appleAppStore:
    "https://apps.apple.com/us/app/parachute-plasma-donation/id1519284283",
  facebook: "https://www.facebook.com/Join-Parachute-103668707964239",
  facebookShare: "https://facebook.com/sharer/sharer.php?u=",
  googleFonts:
    "https://fonts.googleapis.com/css2?family=Martel+Sans:wght@400;600;800&family=Poppins:ital,wght@0,400;0,600;0,800;1,400;1,600;1,800&display=swap",
  googlePlayStore:
    "https://play.google.com/store/apps/details?id=com.buoysoftware.parachute",
  greenhouseBoard:
    "https://boards-api.greenhouse.io/v1/boards/joinparachute/jobs",
  instagram: "https://www.instagram.com/joinparachute/",
  twitter: "https://twitter.com/joinparachute",
  twitterShare: "https://twitter.com/intent/tweet?text=",
}

export const appleAppStoreId = "1519284283"

export type ExternalLinkHref = keyof typeof externalLinks

export default externalLinks
